import { GUEST_TOKEN_NAME } from '@/services/Configuration'

export const clearSavedGuestToken = () => {
  localStorage.removeItem(GUEST_TOKEN_NAME) // consider sessionStorage?
}
